const getParams = (query) => Object.entries(query)
    .filter(([_, value]) => value != null)
    .map(([key, value]) => `${key}=${value}`)
    .sort() // To improve cache hit rate
    .join('&');
const appendParams = (url, query) => {
    const queryString = getParams(query);
    return `${url}${queryString ? (url.indexOf('?') === -1 ? '?' : url.endsWith('?') ? '' : '&') : ''}${queryString}`;
};

export { appendParams, getParams };
//# sourceMappingURL=urlUtils.js.map
